module.exports = __webpack_public_path__ + "img/301.orange.b829a25c.gif";